<template>
  <div class="box10">
    <pageTitle
      title="感恩老学员口碑力荐"
      text="宣传好，不如学员评价好！"
      titleColor="#1A0400"
      titColor="#665552"
    />
    <studentEvaluation
      :evaluateData="evaluateData"
      :styleData="styleData"
      @provideIndex="provideIndex"
      scrollColor="#ffab9a"
      blockColor="#ff5731"
    />
    <!-- <div class="txt">
      * 资料来源：博学谷软件测试学科班主任老师与同学们的日常沟通截图
    </div> -->
    <previewImage
      ref="previewImage"
      :clickedIndex="clickedIndex"
      :isPreview="isPreview"
      type="img"
      :targetImg="evaluateData[this.cur].imgUrlList[this.clickedIndex].img"
      @close="close"
    />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import previewImage from "../common/previewImage.vue";
import studentEvaluation from "../common/student-evaluation.vue";
export default {
  components: {
    pageTitle,
    studentEvaluation,
    previewImage,
  },

  data() {
    return {
      clickedIndex: 0,
      isPreview: false,
      cur: 0,
      evaluateData: [
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/newMedia/box10/1.png"),
              id: 1,
            },
            {
              img: require("../../../assets/coursePage/newMedia/box10/2.png"),
              id: 2,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/newMedia/box10/3.png"),
              id: 3,
            },
            {
              img: require("../../../assets/coursePage/newMedia/box10/4.png"),
              id: 4,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/newMedia/box10/5.png"),
              id: 5,
            },
            {
              img: require("../../../assets/coursePage/newMedia/box10/6.png"),
              id: 6,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/newMedia/box10/7.png"),
              id: 7,
            },
            {
              img: require("../../../assets/coursePage/newMedia/box10/8.png"),
              id: 8,
            },
          ],
        },
      ],

      titleColor: "#3E4F48",

      styleData: {
        imgBorder: "border:0.053333rem  solid #FFAB9A;",
        imgHoverBorder: "border: 0.053333rem  solid #FF5731;",
      },
    };
  },
  methods: {
    provideIndex(index, index1) {
      this.clickedIndex = index1;
      this.cur = index;
      this.isPreview = true;
    },
    close() {
      this.isPreview = false;
      this.clickedIndex = 0;
      this.cur = 0;
      // this.imageUrl = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.box10 {
  padding: 80px 0 88px;
  width: 100%;
  background: #fef1ec url("../../../assets/coursePage/newMedia/box10/bgc.png")
    no-repeat;
  background-size: cover;
  background-position: top center;
  font-size: 4px;
  .txt {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #b9c8d9;
    line-height: 20px;
    text-align: center;
    margin-top: 70px;
  }
}
</style>
